import { RouteObject } from "react-router";

import { PortalPage } from "@layouts/PortalPage/PortalPage.layout";

import { routes } from "@pages/routes";

import { Profile } from "./Profile/Profile.page";

export const profileRoutes = [
  {
    path: routes.portal.profile.$path(),
    Component: PortalPage,
    children: [
      {
        index: true,
        Component: Profile,
        handle: {
          breadcrumb: {
            title: "Profile",
          },
        },
      },
    ],
  },
] satisfies RouteObject[];
